(() => {
  const HIDDEN = 'almam-sticky-header--hidden';
  const FIXED = 'almam-sticky-header';
  const PRAG_MISCARE = 6;

  const header = document.querySelector('header.header');
  if (!header) return;

  const slot = header.closest('.shopify-section') || header.parentElement;
  let inaltime = 0;
  let declansare = 0;
  let ultimulScroll = window.scrollY;
  let programat = false;

  const masoara = () => {
    const eraFixat = header.classList.contains(FIXED);
    if (eraFixat) header.classList.remove(FIXED);
    slot.style.height = '';
    inaltime = header.offsetHeight;
    declansare = slot.getBoundingClientRect().top + window.scrollY;
    slot.style.height = `${inaltime}px`;
    if (eraFixat) header.classList.add(FIXED);
  };

  const drawerDeschis = () =>
    document.body.classList.contains('overflow-hidden') ||
    !!document.querySelector('details[open] > .header__drawer, .menu-drawer-container[open]');

  const actualizeaza = () => {
    programat = false;
    const y = window.scrollY;
    const delta = y - ultimulScroll;

    if (y <= declansare) {
      header.classList.remove(FIXED, HIDDEN);
      ultimulScroll = y;
      return;
    }

    header.classList.add(FIXED);

    if (Math.abs(delta) < PRAG_MISCARE) return;

    const ascunde =
      delta > 0 &&
      y > declansare + inaltime &&
      !drawerDeschis() &&
      !header.contains(document.activeElement);

    header.classList.toggle(HIDDEN, ascunde);
    ultimulScroll = y;
  };

  const laScroll = () => {
    if (programat) return;
    programat = true;
    requestAnimationFrame(actualizeaza);
  };

  masoara();
  actualizeaza();

  window.addEventListener('scroll', laScroll, { passive: true });
  window.addEventListener('resize', () => {
    masoara();
    actualizeaza();
  });
  document.addEventListener('shopify:section:load', masoara);
})();
